<div class="container">
  <div *ngIf="mostrarFiltroPendencias" class="row">
    <div class="col-md-4 text-center">
      <input type="radio" name="comPendencias" value="undefined" [(ngModel)]="estadoFiltroPendencias[tipoPendencia]" (change)="trocaOpcaoComPendencias($event.target.value)" />
      Todas
    </div>
    <div class="col-md-4 text-center">
      <input type="radio" name="comPendencias" value="true" [(ngModel)]="estadoFiltroPendencias[tipoPendencia]" (change)="trocaOpcaoComPendencias($event.target.value)" />
      Com inconsistência
    </div>
    <div class="col-md-4 text-center">
      <input type="radio" name="comPendencias" value="false" [(ngModel)]="estadoFiltroPendencias[tipoPendencia]" (change)="trocaOpcaoComPendencias($event.target.value)" />
      Sem inconsistência
    </div>
  </div>
</div>

<div class="container mt-3 mx-auto">

        <div class="alert alert-info" *ngIf="!recuperacoesCredito || !recuperacoesCredito.length">
          Não foram encontradas recuperações de crédito com os filtros informados.
        </div>

        <div class="row" *ngIf="recuperacoesCredito && recuperacoesCredito.length">
          <div *ngIf="mostrarExportarRecuperacoes">
            <button  class="btn btn-secondary float-end" type="button" (click)="exportarRecuperacoesCredito()"
              placement="top" ngbTooltip="Exporta todas as recuperações de crédito listadas">
            <i class="fa fa-file"></i> Exportar Recuperações</button>
          </div>

          <bn-paginacao [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th id="col-agente" scope="col">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'id'"
                        [nomeAtributoExibicao]="'ID'" (aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>
                    <th *ngIf="!ehAgenteFinanceiro" id="col-agente" scope="col">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgenteFinanceiro'"
                        [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>
                    <th id="col-id-operacao-externo" scope="col">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idOperacaoExterno'"
                        [nomeAtributoExibicao]="'Id. ext. operação'" (aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>
                    <th id="col-sistema-contrato" scope="col">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'contratoRepasse'" 
                          [nomeAtributoExibicao]="'Sist./Contrato'"(aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>  
                    <th id="col-data-envio" scope="col" *ngIf="mostrarDatasValores">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'"
                        [nomeAtributoExibicao]="'Data de envio'" (aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>
                    <th id="col-data-recuperacao" scope="col" *ngIf="mostrarDatasValores">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataRecuperacao'"
                        [nomeAtributoExibicao]="'Data recup.'" (aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>
                    <th id="col-nome-valorRecuperacao" scope="col"  class="moeda" *ngIf="mostrarDatasValores">
                        <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorRecuperacao'" [nomeAtributoExibicao]="'Val. recup.'"
                          (aoClickar)="mudancaOrdenacao($event)">
                        </bn-ordenacao>
                      </th>
                      <th id="col-nome-valorDevidoAoFgiPeac" scope="col"  class="moeda" *ngIf="mostrarDatasValores">
                        <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorDevidoAoFgiPeac'" [nomeAtributoExibicao]="'Val. devido'"
                          (aoClickar)="mudancaOrdenacao($event)">
                        </bn-ordenacao>
                      </th>
                    <th id="col-estado" scope="col">
                      <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'estado'" [nomeAtributoExibicao]="'Estado'"
                        (aoClickar)="mudancaOrdenacao($event)">
                      </bn-ordenacao>
                    </th>
                    <th scope="col" *ngIf="mostrarFiltroPendencias">Ações</th> <!--lupa para visualizar os detalhes-->
                    <th scope="col" *ngIf="mostrarFiltroPendencias"></th>
                    <th scope="col" *ngIf="mostrarFiltroPendencias && podeEditar"></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let recuperacao of recuperacoesCredito; let i = index">
                    <tr [routerLink]="!mostrarFiltroPendencias ? ['/recuperacoes-credito', recuperacao.id] : []"
                     [ngClass]="!mostrarFiltroPendencias?'pointer':''">
                      <td>{{ recuperacao.id }}</td>
                      <td *ngIf="!ehAgenteFinanceiro" >{{ nomeAgente(recuperacao.cnpjAgenteFinanceiro) }}</td>
                      <td>{{ recuperacao.idOperacaoExterno }}</td>
                      <td>{{ recuperacao.contratoRepasse ? recuperacao.sistemaRepasse + '/' + recuperacao.contratoRepasse : ''}}</td>
                      <td *ngIf="mostrarDatasValores">{{ recuperacao.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
                      <td *ngIf="mostrarDatasValores">{{ recuperacao.dataRecuperacao | date: 'dd/MM/yyyy'}}</td>
                      <td class="moeda" *ngIf="mostrarDatasValores">{{ recuperacao.valorRecuperacao | bnMask: 'MOEDA'}}</td>
                      <td class="moeda" *ngIf="mostrarDatasValores">{{ recuperacao.valorDevidoAoFgiPeac | bnMask: 'MOEDA'}}</td>
                      <td>{{ recuperacao.estado?.nomeEstado }}</td>
                      <td *ngIf="mostrarFiltroPendencias">
                        <a [routerLink]="['/recuperacoes-credito', recuperacao.id]" >
                          <i class="fa fa-search" aria-hidden="true" placement="left-top" ngbTooltip="Visualizar detalhes"> </i>
                        </a>
                      </td>
                      <td *ngIf="mostrarFiltroPendencias && existePendencia(recuperacao)">
                        <p class="text-danger"><i class=" fa fa-exclamation" aria-hidden="true" placement="left-top" ngbTooltip="Pendência existente"> </i></p>
                      </td>
                      <td *ngIf="mostrarFiltroPendencias && !existePendencia(recuperacao)">
                        <a href="javascript:void(0)" (click)="mostrarCamposExibicaoResolucao(recuperacao)">
                          <p class="text-success"><i class=" fa fa-check" aria-hidden="true" placement="left-top" ngbTooltip="Sem pendências"> </i></p>
                        </a>
                      </td>
                      <td *ngIf="mostrarFiltroPendencias && existePendencia(recuperacao) && podeEditar">
                        <a href="javascript:void(0)" (click)="mostrarCamposInclusaoResolucao(recuperacao)">
                          <i class=" fa fa-plus" aria-hidden="true" placement="left-top" ngbTooltip="incluir resolução"> </i>
                        </a>
                      </td>
                      <td *ngIf="mostrarFiltroPendencias && !existePendencia(recuperacao) && podeEditar">
                        <a href="javascript:void(0)" bnConfirm tituloConfirm="Confirmação" msgConfirm="Tem certeza de que deseja excluir a resolução?"
                        (onConfirm)="excluirResolucao(recuperacao)">
                         <i class=" fa fa-minus" aria-hidden="true" placement="left-top" ngbTooltip="Excluir resolução"> </i>
                       </a>
                     </td>
                    </tr>
                    <tr *ngIf="recuperacao.deveMostrarCamposInclusaoResolucao">
                      <td colspan="14">
                        <div class="row">
                          <div class="col-md-12">
                            <label for="mensagem"><b>Observações</b></label>
                            <textarea class="form-control" name="observacoes{{i}}" id="observacoes{{i}}" [(ngModel)]="recuperacao.observacoesInclusaoResolucao"
                                required minlength="2" maxlength="1000" rows="3"></textarea>
                            <button type="button" class="btn btn-primary" (click)="incluirResolucao(recuperacao, recuperacao.observacoesInclusaoResolucao)">Salvar</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="recuperacao.resolucaoEmExibicao">
                      <td colspan="14">
                        <div class="row">
                          <div class="col-md-12">
                            <label for="mensagem"><b>Observações</b></label>
                            <textarea class="form-control" name="consultaObservacoes{{i}}" id="consultaObservacoes{{i}}" [(ngModel)]="recuperacao.resolucaoEmExibicao.observacoes" disabled></textarea>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label for="mensagem"><b>Usuário</b></label>
                            <input type="text" class="form-control" name="usuarioCriacao{{i}}" [(ngModel)]="recuperacao.resolucaoEmExibicao.usuarioCriacao" disabled>
                          </div>
                          <div class="col-md-6">
                            <label for="mensagem"><b>Data</b></label>
                            <bn-datepicker [(ngModel)]="recuperacao.resolucaoEmExibicao.dataCriacao" [disabled]="true" name="dataCriacao{{i}}" idInput="dataCriacao{{i}}"></bn-datepicker>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </bn-paginacao>
        </div>
      </div>